<template>
  <symbol
    id="facebook-outline"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 1.516c4.691 0 8.485 3.8 8.485 8.484 0 4.15-2.955 7.55-6.854 8.315v-5.51h2.245l.493-3.196h-2.738v-.857c0-.441.08-.836.216-1.073.136-.238.267-.346.587-.346h1.887V4.495L14 4.445c-.301-.034-.882-.115-1.93-.115-1.147 0-2.07.337-2.81 1.02-.68.65-1.016 1.763-1.016 3.124V9.61H6v3.195h2.244v5.483C4.407 17.474 1.515 14.105 1.515 10A8.482 8.482 0 0 1 10 1.516zm0-.85C4.85.667.667 4.858.667 10c0 4.697 3.448 8.572 8 9.248l.426.085v-7.378H6.888V10.46h2.205V8.474c0-1.223.293-2.029.778-2.474.485-.565 1.201-.82 2.199-.82.797 0 1.108.048 1.403.084V6.49h-1.039c-.589 0-1.1.329-1.323.767-.25.439-.329.962-.329 1.496v1.707h2.598l-.231 1.495h-2.367v7.38h.482c4.554-.685 8.07-4.591 8.07-9.334C19.333 4.857 15.15.666 10 .666z"
    />
  </symbol>
</template>
